var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoResults = function SvgNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 199 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M99.421 0v200h99V0h-99Z",
    fill: "#61D8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.99 42.431 141.42 0l56.569 56.569L155.558 99l.064.064 21.395 21.394 21.394 21.395-28.284 28.284-28.284 28.284-42.853-42.852-21.027 21.026L56.57 197.99l-28.285-28.284L0 141.421 42.421 99l-42-42L56.99.431l42 42Z",
    fill: "#2E72DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m99.421 42 42-42 56.569 56.569L155.558 99l.064.064 21.395 21.394 21.394 21.395-28.284 28.284-28.284 28.284L99.421 156V42Z",
    fill: "#2E72DF"
  })));
};
export default SvgNoResults;